import { Component, input, output, inject, ChangeDetectionStrategy } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';

@Component({
  selector: 'app-email-input',
  imports: [ReactiveFormsModule],
  templateUrl: './email-input.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './email-input.component.scss'
})
export class EmailInputComponent {
  disabled = input(false);
  emailSubmitted = output<string>();

  private fb = inject(FormBuilder);
  emailForm: FormGroup;

  constructor() {
    this.emailForm = this.fb.group({
      email: ['', [Validators.required, Validators.email]]
    });
  }

  onSubmit(): void {
    if (this.emailForm.valid) {
      this.emailSubmitted.emit(this.emailForm.value.email);
    }
  }
}
